<script lang="ts">
    import { fade } from "svelte/transition"
    import { Router, Route, links, link } from "svelte-routing"
    import { scrollToTop } from "svelte-scrollto"

    import { location, generalInformation } from "../store"

    import Content from "./routes/Content.svelte"
    import Home from "./routes/Home.svelte"
    import ArticleDetails from "./routes/ArticleDetails.svelte"
    import Events from "./routes/Events.svelte"
    import Contact from "./routes/Contact.svelte"

    import Carousel from "./page/Carousel.svelte"

    export let url = ""
    if (url) {
        // ssr
        let l = url.split("?")
        $location = {
            path: l[0],
            search: l.length > 1 ? l[1] : "",
            categoryPath: l[0].replace(/\/\d{4,99}[^\/]+$/, ""),
            push: false,
            pop: false,
        }
    }

    // scroll to top on new site
    location.subscribe((l) => {
        if (l.push) scrollToTop()
    })

    let y = 0

    let activeSlide = 2
    window.setInterval(() => {
        activeSlide = activeSlide === 2 ? 0 : activeSlide + 1
    }, 4000)

    if (typeof window !== "undefined") console.log("App initialized")

    let showNav

    let audioPlayer
    let isPlaying = false
</script>

<svelte:window bind:scrollY="{y}" />

<header class:scroll="{y > 50}">
    <div class="container layout justify-content-end">
        <div class="service-bar layout layout-gap-md">
            <span> Tel.: {$generalInformation?.tel}</span>
            <span>Mob.: {$generalInformation?.mobile}</span>
            <span>{$generalInformation?.email}</span>
        </div>
    </div>
    <div class="container">
        <div class="layout justify-content-space-between align-items-start">
            <a class="brand" href="/" use:link>
                <img src="/assets/page/logo.gif" alt="Svend Walter" />
            </a>
            <nav>
                <ul class="layout layout-gap-lg">
                    <li>
                        <a
                            href="/services"
                            use:link
                            class:active="{$location.path === '/services'}"
                            >Meine buchbaren Leistungen</a
                        >
                    </li>
                    <li>
                        <a
                            href="/kontakt"
                            use:link
                            class:active="{$location.path === '/kontakt'}"
                            >Kontaktformular</a
                        >
                    </li>
                    <li>
                        <a
                            href="/hoerproben"
                            use:link
                            class:active="{$location.path === '/hoerproben'}"
                            >Hörproben / Videos</a
                        >
                    </li>
                    <li>
                        <a
                            href="/ton-licht"
                            use:link
                            class:active="{$location.path === '/ton-licht'}"
                            >Ton & Licht</a
                        >
                    </li>
                </ul>
            </nav>
            <img
                src="/assets/page/menu.svg"
                alt="Navigation Toggle"
                class="navToggle"
                on:click="{() => (showNav = !showNav)}"
            />
        </div>
        <nav class="mobile" class:show="{showNav}">
            <ul class="layout layout-gap-lg layout-vertical mb-lg">
                <li>
                    <a
                        href="/services"
                        use:link
                        class:active="{$location.path === '/services'}"
                        on:click="{() => (showNav = false)}"
                        >Meine buchbaren Leistungen</a
                    >
                </li>
                <li>
                    <a
                        href="/kontakt"
                        use:link
                        class:active="{$location.path === '/kontakt'}"
                        on:click="{() => (showNav = false)}">Kontaktformular</a
                    >
                </li>
                <li>
                    <a
                        href="/hoerproben"
                        use:link
                        class:active="{$location.path === '/hoerproben'}"
                        on:click="{() => (showNav = false)}">Hörproben</a
                    >
                </li>
                <li>
                    <a
                        href="/ton-licht"
                        use:link
                        class:active="{$location.path === '/ton-licht'}"
                        on:click="{() => (showNav = false)}">Ton & Licht</a
                    >
                </li>
            </ul>
        </nav>
    </div>
</header>

<Carousel>
    {#if activeSlide === 0}
        <div
            transition:fade
            class="col carousel-slide"
            style="background-image: url(assets/page/carousel-bg-1.png);"
        >
            <div class="container">
                <img
                    src="assets/page/carousel-svend-1.png"
                    alt="Svend Walter"
                />
                <div class="content">
                    <div class="headline">Herzlich Willkommen</div>
                    <ul class="text">
                        <li>Entertainer, Moderator, DJ</li>
                        <li>
                            Live-Musik (Keyboard, Akkordeon, Klavier)<br />mit
                            Top-Live-Gesang
                        </li>
                        <li>Musikalische Unterhaltungsprogramme</li>
                    </ul>
                </div>
            </div>
        </div>
    {/if}
    {#if activeSlide === 1}
        <div
            transition:fade
            class="col carousel-slide"
            style="background-image: url(assets/page/carousel-bg-2.png);"
        >
            <div class="container">
                <img src="assets/page/svend_akkordion.png" alt="Svend Walter" />
                <div class="content">
                    <div class="headline">Herzlich Willkommen</div>
                    <ul class="text">
                        <li>Entertainer, Moderator, DJ</li>
                        <li>
                            Live-Musik (Keyboard, Akkordeon, Klavier)<br />mit
                            Top-Live-Gesang
                        </li>
                        <li>Musikalische Unterhaltungsprogramme</li>
                    </ul>
                </div>
            </div>
        </div>
    {/if}
    {#if activeSlide === 2}
        <div
            transition:fade
            class="col carousel-slide"
            style="background-image: url(assets/page/carousel-bg-3.png);"
        >
            <div class="container">
                <img
                    src="assets/page/carousel-svend-3.png"
                    alt="Svend Walter"
                />
                <div class="content">
                    <div class="headline">Herzlich Willkommen</div>
                    <ul class="text">
                        <li>Entertainer, Moderator, DJ</li>
                        <li>
                            Live-Musik (Keyboard, Akkordeon, Klavier)<br />mit
                            Top-Live-Gesang
                        </li>
                        <li>Musikalische Unterhaltungsprogramme</li>
                    </ul>
                </div>
            </div>
        </div>
    {/if}
</Carousel>

<div class="wave-top wave"></div>

<Router url="{url}">
    <Route path="/articles/:id" let:params>
        <ArticleDetails id="{params.id}" />
    </Route>
    <Route path="/*path" let:params>
        <Content path="/{params.path}" />
    </Route>
    <Route path="/events" let:params>
        <Events />
    </Route>
    <Route path="/kontakt" let:params>
        <Contact />
    </Route>
    <Route path="/" let:params>
        <Home />
    </Route>
</Router>

<footer use:links>
    <div class="wave"></div>
    <div class="container">
        <div><a href="/impressum">Impressum</a></div>
        <div class="mt-xs"><a href="/datenschutz">Datenschutz</a></div>
        <div class="mt-md">
            Kontakt: {$generalInformation?.street}, {$generalInformation?.postcode}
            {$generalInformation?.city}
        </div>
    </div>
</footer>

<style lang="less" global>
    @import "./../css/main.less";
</style>
